((window) => {
    if (!document.querySelector('[data-behaviour="open-accordion"]')) return;

    const clearPreviousActiveStates = (rows, buttons) => {
        rows.map((row) => row.classList.remove("active"));
        buttons.map((button) => button.classList.remove("active"));
    };

    const toggleAccordion = (row, buttons, active) => {
        const dir = active ? "remove" : "add";

        row.classList[dir]("active");
        buttons.map((button) => button.classList[dir]("active"));
    };

    const showAccordion = (row, buttons) => {
        toggleAccordion(row, buttons, false);
    };
    const hideAccordion = (row, buttons) => {
        toggleAccordion(row, buttons, true);
    };

    const getAccordionElements = (target) => {
        const row = document.querySelector(`[data-row="${target}"]`);
        const accordion = row.closest(`[data-target="accordion"]`);
        const rows = [...document.querySelectorAll("[data-row]")];
        const buttons = [
            ...document.querySelectorAll(`[data-target="${target}"]`),
        ];
        const allButtons = [...document.querySelectorAll('[data-target]')];
        const isActive = row.matches(".active");

        return { accordion, row, rows, buttons, allButtons, isActive };
    };

    const scrollToRow = (accordion, row) => {
        const rowHeight = row.offsetHeight;
        const accordionOffset = accordion.offsetTop;
        const index = [...row.parentElement.children].indexOf(row);
        const scrollTo = rowHeight * index + accordionOffset;

        window.scrollTo({ top: scrollTo, behavior: "smooth" });
    };

    document.addEventListener("click", (e) => {
        if (!e.target.matches('[data-behaviour="open-accordion"]')) return;

        const {
            accordion,
            row,
            rows,
            buttons,
            allButtons,
            isActive,
        } = getAccordionElements(e.target.dataset.target);

        if (isActive) {
            hideAccordion(row, buttons);
        } else {
            clearPreviousActiveStates(rows, allButtons);
            showAccordion(row, buttons);
            scrollToRow(accordion, row);
        }
    });
})(window);
